/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner model module.
 * @module model/BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner
 * @version 1.0.0
 */
class BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner {
    /**
     * Constructs a new <code>BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner</code>.
     * @alias module:model/BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner
     */
    constructor() { 
        
        BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner} obj Optional instance to populate.
     * @return {module:model/BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner} The populated <code>BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('details')) {
                obj['details'] = ApiClient.convertToType(data['details'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}



/**
 * @member {String} code
 */
BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner.prototype['code'] = undefined;

/**
 * @member {String} message
 */
BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner.prototype['message'] = undefined;

/**
 * @member {Object} details
 */
BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner.prototype['details'] = undefined;






export default BasketsValidatePost400ResponseValidationErrorsInnerErrorsInner;

